import { ILogin } from "domain/ILogin";
import classes from "../styles/LoginsPopover.module.scss";

interface IProps {
  logins: ILogin[];
}

const LoginsPopover = ({ logins }: IProps) => {
  const translateReason = (sessionEndReason: string) => {
    if (sessionEndReason === "SYSTEM_ERROR") {
      return "Sistemska greška";
    }
    return "";
  }

  return (
    <>
      <div className={classes.modalContent}>
        <div>
          <div className={`${classes.content}`}>
            <div className={classes.table}>
              <div className={`g-grid g-header ${classes.gHeader}`}>
                <div className={`row ${classes.row}`}>
                  <div className="col center lowercase separator-line">
                    korisnik</div>
                  <div className="col center lowercase separator-line">
                    vreme prijave</div>
                  <div className="col center lowercase separator-line">
                    vreme odjave</div>
                  <div className="col center lowercase">
                    ukupno</div>
                  <div></div>
                </div>
              </div>
              <div
                className={`g-grid g-content ${classes.gContent} loading-container`}
              >
                {logins.map((login, index) => (
                  <div className={`row ${classes.row}`} key={index} tabIndex={index}>
                    <div className={`col ${classes.col} light center`}>
                      <div className={`bg-item right`}>
                        {login.username}
                      </div>
                    </div>
                    <div className={`col ${classes.col} light center`}>
                      <span>{login.loginAtDate}</span>&nbsp;<span className={classes.black}>- {login.loginAtTime}</span>
                    </div>
                    <div className={`col ${classes.col} light center`}>
                      {login.sessionEndReason === "REGULAR" && (<><span>{login.sessionEndAtDate}</span>&nbsp;<span className={classes.black}>- {login.sessionEndAtTime}</span></>)}
                      {login.sessionEndReason !== "REGULAR" && (<span className={classes.black}>{translateReason(login.sessionEndReason)}</span>)}
                    </div>
                    <div className={`col ${classes.col} light center`}>
                      <div className={`bg-item center`}>
                        {login.sessionDuration}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>


      </div>
    </>
  );
};

export default LoginsPopover;
